import { Props } from './types';
import * as Styled from './styled';

function Label({ children, htmlFor, disabled, error, className }: Props) {
  return (
    <Styled.Label
      htmlFor={htmlFor}
      className={className}
      $disabled={disabled}
      $error={error}
    >
      {children}
    </Styled.Label>
  );
}

export default Label;
